module.exports = __webpack_public_path__ + "static/media/sikkim.f439c261.png";